import { ApiClient } from '@k2/common/backend/api-client';
import {
  ServiceDatesDataObject
} from "../../../staff/content/clients/client/assignment/service/service-dates-section/service-dates-section.component";

export class FinanceDatesEndpoint {
  constructor(private api: ApiClient) {

  }

  upsertFinanceDatesDate = (assignmentServiceInstanceId: number, payload: ServiceDatesDataObject) => {
    return this.api.post(
      `/assignment-service-instance/${assignmentServiceInstanceId}/finance-dates/upsert-date`,
      payload
    );
  };
}
